const TONE_COUNT = 4;

export interface PortraitProps {
  /** Vorname und Nachname für die Initialen und die gleichbleibende Tönung. */
  firstName?: string | null;
  lastName?: string | null;
  /** Foto (Objekt-URL); ohne Foto erscheinen die Initialen. */
  src?: string;
  size?: "default" | "large";
}

const letter = (value?: string | null) => (value ?? "").match(/\p{L}/u)?.[0] ?? "";

/** Porträt einer Person (Kit): Foto oder Initialen auf einer aus dem Namen abgeleiteten Tönung. */
export function Portrait({ firstName, lastName, src, size = "default" }: PortraitProps) {
  const initials = `${letter(firstName)}${letter(lastName)}`.toUpperCase() || "?";
  const tone = [...`${firstName ?? ""}${lastName ?? ""}`].reduce((sum, c) => sum + c.charCodeAt(0), 0) % TONE_COUNT;
  return (
    <span className={`ck-portrait ck-portrait--${tone}${size === "large" ? " ck-portrait--large" : ""}`} aria-hidden="true">
      {src ? <img src={src} alt="" /> : initials}
    </span>
  );
}
